import { useAuth } from './Auth'

// Frontend-only gate for hide/disable UX. The server (see
// middlewares/permission.middleware.js in callgenie-backend) is the real
// enforcement point and stays permissive during rollout — this hook has no
// equivalent fallback, since hiding a button an admin could still technically
// reach is a minor cosmetic gap, while showing one that then 403s is worse.
export function usePermission() {
  const { currentUser } = useAuth()
  const permissions = currentUser?.permissions ?? []
  const isSuperAdmin = !!currentUser?.is_super_admin || permissions.includes('*')

  const hasPermission = (...required: string[]) =>
    isSuperAdmin || required.every((p) => permissions.includes(p))

  const hasAnyPermission = (...required: string[]) =>
    isSuperAdmin || required.length === 0 || required.some((p) => permissions.includes(p))

  return { hasPermission, hasAnyPermission, isSuperAdmin, adminRole: currentUser?.admin_role }
}
